// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uJdp","largestCol":"styles_largestCol__RMjxf","smallestCol":"styles_smallestCol__3iOkM"};